import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.1.139/api/', // api的base_url
  baseURL: 'http://t-softs.xsfaya.com/', // api的base_url
  timeout: 5000 // 请求超时时间
})
const BASE_URL = 'http://xs-store.xsfaya.com'
Vue.prototype.$BASE_URL = BASE_URL
Vue.prototype.$axios = service

Vue.use(ElementUI)

// 取消打印
// console.log = () => {}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
